import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import EventBus from '@/eventBus';

export const PopupHelpersVue = {
  mixins: [AjaxHelpersVue],

  methods: {
    requestPopup(api, params) {
      this.req(api, params, res => {
        EventBus.$emit('eventPopupDataLoaded', res);
      });
    },

    popup(type, action, id = '') {

      // Booking
      if(type === 'booking') {
        let $popupBooking = $('.js-popup-booking');

        if(action === 'show') {
          if(id.length) {
            $('.js-popup-event').removeClass('popup-event--show');

            $popupBooking.find('.js-form-booking-event-id').val(id);
          }

          $popupBooking.addClass('popup-booking--show');

          $('#app').addClass('overflow compensate-scrollbar');
          //this.measureScrollbar();
        }
        else {
          $popupBooking.removeClass('popup-booking--show');
          $('#app').removeClass('overflow compensate-scrollbar');
        }
      }

      // Event
      let $popupEvent = $('.js-popup-event');

      if(type === 'event') {

        if(action === 'show') {
          this.requestPopup('Event:getEvent', {id});
        }
        else {
          $popupEvent.removeClass('popup-event--show');
        }

        this.appClasses(action);
      }

      // Message
      let $popupMessage = $('.js-popup-message');

      if(type === 'popupMessage') {

        if(action === 'show') {
          $popupMessage.addClass('popup-message--show');
        }
        else {
          $popupMessage.removeClass('popup-message--show');
        }

        this.appClasses(action);
      }

      // Action
      if(type === 'action') {

        if(action === 'show') {
          this.requestPopup('Action:getAction', {id});
        }
        else {
          $popupEvent.removeClass('popup-event--show');
        }

        this.appClasses(action);
      }
    },

    appClasses(action) {
      if(action === 'show') {
        $('#app').addClass('overflow compensate-scrollbar');

        //this.measureScrollbar();
      }
      else {
        $('#app').removeClass('overflow compensate-scrollbar');
      }
    },

    /**
     * Измерить ширину скроллбара
     * Метод взят из модалки бутстрапа
     */
     measureScrollbar() {
        let scrollDiv = document.createElement('div'),
            $body     = $('body');

        scrollDiv.className = 'modal-scrollbar-measure';

        $(scrollDiv).css({
          position: 'absolute',
          top: '-9999px',
          width: '50px',
          height: '50px',
          overflow: 'scroll'
        });

        $body.append(scrollDiv);

        let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

        $body[0].removeChild(scrollDiv);

        $('head').append(`<style id="compensate">.compensate-scrollbar{padding-right: ${scrollbarWidth}px;}</style>`);
      }
  }
};
